import { LIMPAR_FILTRO_ENCOMENDA } from '../types'

export default function limparFiltroEncomenda () {
  return {
    type: LIMPAR_FILTRO_ENCOMENDA
  }
}
